;(() => {
    if (customElements.get('hoculus-custom-field')) return;

    const ON_CHANGE_DEBOUNCE_TIMER = 300;

    class HoculusCustomField extends HTMLElement {
        variantId = this.dataset.variantId;
        variantPrice = this.dataset.variantPrice;
        formId = this.dataset.formId;
        isRequired = this.dataset.isRequired === 'true';

        template = this.querySelector('template');
        input = this.querySelector('input');  

        connectedCallback() {
            this.input.addEventListener('input', window.hoculus.Utils.debounce(this.onChange.bind(this), ON_CHANGE_DEBOUNCE_TIMER));

            this.form = document.getElementById(this.formId);

            if (this.isRequired) {
                this.form.addEventListener('submit', (evt) => {
                    if (!this.inputIsEmpty()) return;
                    
                    evt.preventDefault();
                    evt.stopImmediatePropagation();

                    this.input.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    this.input.focus();
                    this.input.classList.add('hoculus-field-required');
                }, true);
            }
        }

        onChange() {
            const fieldDataEl = this.querySelector('hoculus-field-data');

            this.input.classList.remove('hoculus-field-required');

            if (this.inputIsEmpty()) return fieldDataEl.remove();
            const content = fieldDataEl ?? this.template.content.cloneNode(true);

            let formattedInputValue = this.formatInputValue();

            content.querySelector('.hoculus-field-data-properties').value = `${formattedInputValue} | + ${this.variantPrice}`;
            if (!fieldDataEl) this.appendChild(content);
        }

        inputIsEmpty() {
            return this.input.value.trim().length === 0;
        }

        formatInputValue() {
            return this.input.type === 'date' ? this.input.value.replace(/-/g, '/') : this.input.value;
        }
    }

    customElements.define('hoculus-custom-field', HoculusCustomField);
})();